<cf-form-field [formGroup]="password">
  <cf-input-label required [size]="labelSize">
    {{ label || ("auth.password" | translate) }}
  </cf-input-label>
  <input
    class="size--lg"
    cf-input
    ngDefaultControl
    formControlName="password"
    autocomplete="new-password"
    [attr.type]="showPassword ? 'text' : 'password'"
  />
  <span cf-input-prefix>
    <svg cfIcon="lock" class="tw:text-gray-40 tw:shrink-0"></svg>
  </span>
  <span cf-input-suffix class="password-toggle tw:text-gray-40">
    <svg [cfIcon]="showPassword ? 'eye_close' : 'eye_open'" (click)="showPassword = !showPassword"></svg>
  </span>

  <cf-input-error [error]="password.controls.password.errors">
    {{ label || ("auth.password" | translate) }}
  </cf-input-error>
</cf-form-field>
<div *ngIf="showPasswordStrength && password.value.password">
  <password-strength-meter
    [colors]="['#af1d1d', '#af1d1d', '#fecb01', '#6ac883', '#089141']"
    [className]="'my-2'"
    (strengthChange)="onStrengthChanged($event)"
    [password]="passwordValue"
  ></password-strength-meter>
  <cf-text weight="400" size="xs" [color]="passwordColor">
    {{ "forms.password_input.strength.label" | translate }} {{ " " }} {{ passwordStrengthName | async }}.
  </cf-text>
</div>
